<template>
  <section class="d-flex flex-column align-items-center justify-content-center mt-5 mb-5" 
  :class=" defaultSite.isStudent ? 'container-fluid m-0' : 'container-fluid' ">
    <progress-bar
      :defaultSite="defaultSite"
      :step3Active="isActive"
    ></progress-bar>
    <div class="row col-10 mx-auto bg-light">
      <div class="col-md-4">
   
          <div class="card">
            <div class="tf-vue-bg-grey-dark flex-column text-center justify-content-center align-items-center p-3"
            >
              <div class="summary-title-container">
                <div v-if="tripDetails.quoteType !== 'BACKPACKER'" class="summary-title">
                  <h2 class="fs-5">Summary of Cover</h2> 
                </div>
                <div v-else class="text-center">
                  <h2 class="fs-5">Summary of Cover</h2> 
                </div>
                <div v-if="tripDetails.quoteType !== 'BACKPACKER'" class="defaqto-logo">
                  <img width="100" height="70" src="https://cdn.trailfinders.com/3dauu2dhtm_travel-insurance-rating-category-and-year-5-colour-rgb.png" />
                </div>
              </div>
              <!-- <h2 class="fs-5">Summary of Cover</h2> -->
              <h3 v-if="(tripDetails.quoteType === 'SINGLEG')">Trailfinders Single Trip policy</h3>
              <h3 v-if="(tripDetails.quoteType === 'ANNUALG')">Trailfinders Annual Multi-Trip policy</h3>
              <h3 v-if="(tripDetails.quoteType === 'BACKPACKER')">Trailfinders Backpacker policy</h3>
            </div>
            <div class="card-body tf-vue-bg-grey-light p-1 d-flex flex-column align-items-center">
              <ul v-if="(tripDetails.quoteType === 'SINGLEG')">
                <li>
                  <span v-if="defaultSite.domain === 'ie'">{{ cover.ie.cancellation }}</span>
                  <span v-else>{{ cover.uk.cancellation }}</span>pp cancellation and curtailment cover.
                </li>
                <li>
                  <span v-if="defaultSite.domain === 'ie'">{{ cover.ie.medical }}</span>
                  <span v-else>{{ cover.uk.medical }}</span> medical expenses with 365/24/7 emergency assistance.
                </li>
                <li>
                  <span v-if="defaultSite.domain === 'ie'">{{ cover.ie.personalLiability }}</span>
                  <span v-else>{{ cover.uk.personalLiability }}</span> personal liability.
                </li>
                <li>
                  <span v-if="defaultSite.domain === 'ie'">{{ cover.ie.personalAccident }}</span>
                  <span v-else>{{ cover.uk.personalAccident }}</span> personal accident.
                </li>
                <li>
                  <span v-if="defaultSite.domain === 'ie'">{{ cover.ie.baggage }}</span>
                  <span v-else>{{ cover.uk.baggage }}</span>pp baggage cover.
                </li>
                <li>
                  <span v-if="defaultSite.domain === 'ie'">{{ cover.ie.personalMoney }}</span>
                  <span v-else>{{ cover.uk.personalMoney }}</span>pp personal money cover.
                </li>
                <li>
                  <span v-if="defaultSite.domain === 'ie'">{{ cover.ie.passportVisa }}</span>
                  <span v-else>{{ cover.uk.passportVisa }}</span>pp passport &amp; visa cover.
                </li>
                <li>
                  <span v-if="defaultSite.domain === 'ie'">{{ cover.ie.travelDelay }}</span>
                  <span v-else>{{ cover.uk.travelDelay }}</span>pp travel delay cover.
                </li>
                <li>
                  <span v-if="defaultSite.domain === 'ie'">{{ cover.ie.legalExpenses }}</span>
                  <span v-else>{{ cover.uk.legalExpenses }}</span>pp legal expenses.
                </li>
                <li>Wide range of sporting &amp; adventurous activities included.</li>
              </ul> 

              <ul v-if="(tripDetails.quoteType === 'ANNUALG')">
                <li>Same cover limits as the Trailfinders Single Trip policy.</li>
                <li>Unlimited number of trips, anywhere in the world.</li>
                <li>Up to 70 days cover on any one trip.</li>
                <li>28 days Winter Sports cover included free of charge.</li>
                <li>Insured partner/spouse and children covered even if travelling independently of one another.</li>
                <li>Business travel included.</li>
              </ul>

              <ul v-if="(tripDetails.quoteType === 'BACKPACKER')">
                  <li>
                    <span v-if="defaultSite.domain === 'ie'">{{ cover.ieBackpacker.cancellation }}</span>
                    <span v-else>{{ cover.ukBackpacker.cancellation }}</span>pp cancellation &amp; trip interruption cover.
                  </li>
                  <li>Up to 
                    <span v-if="defaultSite.domain === 'ie'">{{ cover.ieBackpacker.medical }}</span>
                    <span v-else>{{ cover.ukBackpacker.medical }}</span> medical expenses with 365/24/7 emergency assistance and automatic cover for certain pre-existing medical conditions.
                  </li>
                  <li>
                    <span v-if="defaultSite.domain === 'ie'">{{ cover.ieBackpacker.personalLiability }}</span>
                    <span v-else>{{ cover.ukBackpacker.personalLiability }}</span> personal liability.
                  </li>
                  <li>
                    <span v-if="defaultSite.domain === 'ie'">{{ cover.ieBackpacker.personalAccident }}</span>
                    <span v-else>{{ cover.ukBackpacker.personalAccident }}</span> personal accident.
                  </li>
                  <li>
                    <span v-if="defaultSite.domain === 'ie'">{{ cover.ieBackpacker.baggage }}</span>
                    <span v-else>{{ cover.ukBackpacker.baggage }}</span>pp baggage cover.
                  </li>
                  <li>
                    <span v-if="defaultSite.domain === 'ie'">{{ cover.ieBackpacker.personalMoney }}</span>
                    <span v-else>{{ cover.ukBackpacker.personalMoney }}</span>pp personal money cover.
                  </li>
                  <li>
                    <span v-if="defaultSite.domain === 'ie'">{{ cover.ieBackpacker.passportVisa }}</span>
                    <span v-else>{{ cover.ukBackpacker.passportVisa }}</span>pp passport &amp; visa cover.
                  </li>
                  <li>
                    <span v-if="defaultSite.domain === 'ie'">{{ cover.ieBackpacker.travelDelay }}</span>
                    <span v-else>{{ cover.ukBackpacker.travelDelay }}</span>pp travel delay cover.
                  </li>
                  <li>
                    <span v-if="defaultSite.domain === 'ie'">{{ cover.ieBackpacker.legalExpenses }}</span>
                    <span v-else>{{ cover.ukBackpacker.legalExpenses }}</span> legal expenses.
                  </li>
                  <li>Wide range of sporting &amp; adventurous activities included.</li>
                  <li>Volunteering, working holidays* &amp; trekking to 7,000 metres included.</li>
                  <li>Temporary return home during the period of cover.</li>
                  <li>No need for proof of return flight.</li>
                  <li>Take out or extend cover whilst travelling.</li>
                  <small>* some exceptions apply.</small>
                </ul>
            </div>
          </div>

          <div id="quoteSummary" class="mt-3">
            <h2>Quote Summary</h2>
          <h6>
            Please make sure that you have provided the correct information
          </h6>
          <hr />
          <ul class="tf-vue-list-unstyled">
            <li>
              Country of residence:<strong class="ms-3">{{ tripDetails.residence }}</strong>
            </li>
            <li v-if="tripDetails.quoteType !== 'ANNUALG'">
              Travelling to:<strong class="ms-3">{{ tripDetails.destination }}</strong>
            </li>
            <li v-if="tripDetails.quoteType === 'ANNUALG'">
              Worldwide Cover:<strong class="ms-3">1 Year</strong>
            </li>
            <li v-if="tripDetails.quoteType !== 'ANNUALG'">
              From:<strong class="ms-3">{{ fromDate }}</strong>
            </li>
            <li v-if="tripDetails.quoteType !== 'ANNUALG'">
              To:<strong class="ms-3">{{ toDate }}</strong>
            </li>
            <li>
              <span class="col">Number of people:</span>
              <strong class="ms-3 row" v-html="tripDetails.numberPeopleString"></strong>
            </li>
            <li v-if="tripDetails.totalAdults === 2 && tripDetails.quoteType == 'ANNUALG'">
              <strong>Adults must be partners or spouse</strong>
            </li>
          </ul>
          <hr />
          <div v-if="tripDetails.quoteType !== 'BACKPACKER'">
          <p>
            <small>
              <strong>Please note:</strong> This policy offers cancellation
              cover of up to <span v-if="defaultSite.domain === 'ie'">{{ cover.ie.cancellation }}</span>
              <span v-else>{{ cover.uk.cancellation }}</span>pp. If you need to extend your cover beyond this please call us on 020 7408 9005.
            </small>
          </p>
        </div>
        <div v-else>
          <small>
            <strong>Please note:</strong> This policy offers cancellation cover of up to {{ cover.ukBackpacker.cancellation }}pp. If you need to extend your cover beyond this, additional cover can be purchased upon completion of your booking via a link on our online portal Viewtrail.
          </small>
        </div>
        </div>

       
        <aside>
          <h2 class="fs-5 mt-3">Summary of Travellers</h2>
          <hr />
          <ul class="list-unstyled">
            <li>
              Country of residence:<br /><strong>{{
                tripDetails.residence
              }}</strong>
            </li>
            <li v-if="tripDetails.quoteType === 'SINGLEG' || 'BACKPACKER'">
              Travelling to:<br /><strong>{{ tripDetails.destination }}</strong>
            </li>
            <li v-if="tripDetails.quoteType === 'ANNUALG'">
              Worldwide Cover:<br /><strong>1 Year</strong>
            </li>
            <li v-if="tripDetails.quoteType !== 'ANNUALG'">
              From:<br /><strong>{{ fromDate }}</strong>
            </li>
            <li v-if="tripDetails.quoteType !== 'ANNUALG'">
              To:<br /><strong>{{ toDate }}</strong>
            </li>
            <li>
              Number of people:<br />
              <strong v-html="tripDetails.numberPeopleString"></strong>
            </li>
            <li
              v-if="
                tripDetails.totalAdults === 2 &&
                  tripDetails.quoteType === 'ANNUALG'
              "
            >
              <strong>Adults must be partners or spouse</strong>
            </li>
          </ul>
          <hr />
          <section class="row">
            <div class="col-12">
              <p
                class="lead text-left"
                v-if="tripDetails.quoteType === 'SINGLEG'"
              >
                Total Price:
                <strong
                  >{{ defaultSite.symbol }}{{ quoteSingle.PREMIUM }}</strong
                >
              </p>
              <p v-if="tripDetails.quoteType === 'ANNUALG'" >
                Total Price:
                <strong
                  >{{ defaultSite.symbol }}{{ quoteAnnual.PREMIUM }}</strong
                >
              </p>
              <p v-if="tripDetails.quoteType === 'BACKPACKER'">
                Total Price:
                <strong
                  >{{ defaultSite.symbol }}{{ quoteBackpacker.PREMIUM }}</strong
                >
              </p>
              <p>
                <small class="fw-bold"
                  >Price includes Government imposed insurance Premium
                  Tax.</small
                >
              </p>
            </div>
            <div class="btn-container mb-5 d-flex justify-content-center">
              <button class="btn btn-dark mt-0 rounded-0 p-3 w-100" @click="goBack">
                <span class="icon-arrow_left tf-orange me-2"></span>Go Back
              </button>
            </div>
          </section>
        </aside>



        <section class="row d-sm-block">
          <div class="col-12">
            <div class="d-flex flex-column mt-4">
     
              <div class="border p-2">
                <a v-if="tripDetails.quoteType !== 'BACKPACKER'"
                  :href="'/travel-insurance/' + defaultSite.ipid"
                  target="_blank"
                  type="button"
                  class="text-dark text-decoration-none d-flex justify-content-center text-center"
                >
                  Insurance Product Information Document
                </a>
                <a v-else
                  :href="'/travel-insurance/' + defaultSite.studentipid"
                  target="_blank"
                  type="button"
                  class="text-dark text-decoration-none d-flex justify-content-center text-center"
                >
                  Insurance Product Information Document
                </a>
              </div>
              <div class="border p-2">
                <a v-if="tripDetails.quoteType !== 'BACKPACKER'"
                  :href="'/travel-insurance/' + defaultSite.policy"
                  target="_blank"
                  type="button"
                  class="text-dark text-decoration-none d-flex justify-content-center text-center"
                >
                  Policy Document
                </a>
                <a v-else
                  :href="'/travel-insurance/' + defaultSite.studentpolicy"
                  target="_blank"
                  type="button"
                  class="text-dark text-decoration-none d-flex justify-content-center text-center"
                >
                  Policy Document
                </a>
              </div>

              <div class="border p-2">
                <adventure-modal :quote="tripDetails.quoteType"> </adventure-modal>
              </div>
             
            </div>
          </div>
        </section>
      </div>

      <div class="col-md-8">
        <div>
          <section class="row mt-5 mt-md-0">
            <div class="col-12 p-0">
              <div v-show="!amexComplete">
                <!-- form -->
                <form
                  class="tf-vue-bg-grey-light p-3"
                  id="apptForm"
                  @submit="onSubmit"
                >
                  <div id="temp-size">
                    <h4>Your Details</h4>
                    <div
                      v-for="(person, index) in tripDetails.peopleAges"
                      :key="index"
                    >
                      <div class="row my-5">
                        <div class="col-12">
                          <h5>Person Aged - {{ person.AGE }}</h5>
                          <!-- TITLE -->
                          <div class="row">
                            <div
                              class="form-group col-12 col-md-4 mb-4"
                              id="right"
                            >
                              <label for="title" class="d-block fw-bold"
                                >Title *</label
                              >
                              <select
                                id="title"
                                class="form-select form-select-lg w-100 p-2"
                                v-model="form['title' + (index + 1)]"
                              >
                                <option
                                  v-for="(item, index) in titleOptions"
                                  :value="item.value"
                                  :key="index"
                                  >{{ item.text }}</option
                                >
                              </select>
                            </div>

                            <!-- FIRST NAME -->
                            <div class="form-group col-12 col-md-4 mb-4">
                              <label for="firstName" class="d-block fw-bold"
                                >First Name *</label
                              >
                              <input
                                id="firstName"
                                class="form-control form-control-lg"
                                v-model.trim="form['firstName' + (index + 1)]"
                              />
                            </div>

                            <!-- SURNAME -->
                            <div class="form-group col-12 col-md-4 mb-4">
                              <label for="lastName" class="d-block fw-bold"
                                >Last Name *</label
                              >
                              <input
                                class="form-control form-control-lg"
                                id="lastName"
                                v-model.trim="form['surName' + (index + 1)]"
                                aria-describedby="input-2-live-feedback"
                              />
                            </div>
                          </div>
                          <!-- DOB -->
                          <label class="d-block fw-bold">Date Of Birth *</label>
                          <div class="row">
                            <div class="form-group col-12 col-md-4 mb-4">
                              <select
                                class="form-select form-select-lg w-100"
                                id="day"
                                v-model="form['dobDay' + (index + 1)]"
                              >
                                <option
                                  v-for="(day, index) in days"
                                  :key="index"
                                  :value="day.value"
                                  >{{ day.text }}</option
                                >
                              </select>
                            </div>
                            <div class="form-group col-12 col-md-4 mb-4">
                              <select
                                id="month"
                                class="form-select form-select-lg w-100"
                                v-model="form['dobMonth' + (index + 1)]"
                              >
                                <option
                                  v-for="(month, index) in months"
                                  :value="month.value"
                                  :key="index"
                                  >{{ month.text }}</option
                                >
                              </select>
                            </div>
                            <div class="form-group col-12 col-md-4 mb-4">
                              <select
                                class="form-select form-select-lg w-100"
                                id="year"
                                v-model="form['dobYear' + (index + 1)]"
                                value-field="value"
                                text-field="name"
                              >
                                <option
                                  v-for="(year, index) in dobYears"
                                  :key="index"
                                  :value="year.value"
                                  >{{ year.name }}</option
                                >
                              </select>
                            </div>
                          </div>
                          <!-- NATIONALITY -->
                          <div class="row">
                            <div id="right" class="form-group col-12 mb-4">
                              <label for="nationality" class="d-block fw-bold"
                                >Nationality *</label
                              >
                              <select
                                class="form-select form-select-lg w-100"
                                id="nationality"
                                v-model="form['nationality' + (index + 1)]"
                                value-field="code"
                              >
                                <option
                                  v-for="(country, index) in countries"
                                  :key="index"
                                  :value="country.description"
                                  >{{ country.description }}</option
                                >
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr />
                    </div>

                    <!-- <hr class="section-devider"/> -->

                    <!-- EMAIL -->
                    <div class="row">
                      <div id="right" class="form-group col-12 col-md-4 mb-4">
                        <label for="input-small" class="fw-bold"
                          >Email address *</label
                        >
                      </div>

                      <div class="form-group col-12 col-md-8 mb-4">
                        <input
                          class="form-control form-control-lg col-12 col-md-5"
                          :class="{ 'tf-vue-is-invalid': $v.form.email.$error }"
                          id="input-7"
                          v-model.trim="$v.form.email.$model"
                          type="email"
                          aria-describedby="input-7-live-feedback"
                          :state="validateState('email')"
                          @change="touchField($v.form.email)"
                        />
                      </div>

                      <!-- TELEPHONE -->
                      <div id="right" class="form-group col-12 col-md-4 mb-4">
                        <label for="input-small" class="fw-bold"
                          >Daytime Telephone Number *</label
                        >
                      </div>

                      <div class="form-group col-12 col-md-8 mb-4">
                        <input
                          class="form-control form-control-lg col-12 col-md-5"
                          :class="{
                            'tf-vue-is-invalid': $v.form.telephone.$error,
                          }"
                          v-model.trim="$v.form.telephone.$model"
                          type="number"
                          aria-describedby="input-8-live-feedback"
                          :state="validateState('telephone')"
                          @change="touchField($v.form.telephone)"
                        />
                      </div>
                    </div>

                    <!-- POST CODE-->
                    <div class="row">
                      <div class="form-group col-12 col-md-4 mb-4">
                        <label
                          v-if="defaultSite.domain === 'ie'"
                          for="input-small"
                          class="fw-bold"
                          >Eircode *</label
                        >
                        <label v-else for="input-small" class="fw-bold"
                          >Postcode *</label
                        >
                      </div>

                      <div
                        class="col-12 col-md-8"
                        v-if="defaultSite.domain === 'ie'"
                      >
                        <input
                          class="form-control form-control-lg"
                          :class="{
                            'tf-vue-is-invalid': $v.form.postcode.$error,
                          }"
                          v-model.trim="$v.form.postcode.$model"
                          :state="validateState('postcode')"
                          aria-describedby="input-10-live-feedback"
                          @change="$v.form.postcode"
                        />
                      </div>

                      <div
                        v-if="defaultSite.domain !== 'ie'"
                        class="form-group col-12 col-sm-5 mb-4"
                      >
                        <input
                          v-if="!addressData"
                          class="form-control form-control-lg"
                          :class="{
                            'tf-vue-is-invalid': $v.form.postcode.$error,
                          }"
                          v-model.trim="$v.form.postcode.$model"
                          :state="validateState('postcode')"
                          aria-describedby="input-10-live-feedback"
                          @change="touchField($v.form.postcode)"
                        />
                      </div>

                      <div
                        v-if="defaultSite.domain !== 'ie'"
                        id="labelDontShow"
                        class="col-12 col-md-2"
                      >
                        <button
                          @click="addressInfo"
                          :class="addressError ? 'error' : 'default'"
                          class="btn p-3 btn-dark rounded-0 w-100 mb-3 m-lg-0"
                          id="btn-width"
                        >
                          Find
                        </button>
                      </div>

                      <div v-if="addressDataReturned" class="form-group col-12">
                        <select
                          v-if="addressDataReturned"
                          class="form-select form-select-lg w-100"
                          v-model="address"
                          @change="fullAddressInfo"
                        >
                          <option disabled selected value>
                            -- Select an address --
                          </option>
                          <option
                            v-for="option in addressOptions"
                            :key="option.format"
                            :value="option"
                            >{{ option.suggestion }}</option
                          >
                        </select>
                      </div>
                    </div>

                    <div
                      class="row align-items-center"
                      v-if="addressFound || defaultSite.domain === 'ie'"
                    >
                      <div id="right" class="form-group col-12 col-md-4 mb-4">
                        <label for="input-small" class="fw-bold"
                          >Address *</label
                        >
                      </div>

                      <div id="right" class="form-group col-12 col-md-8 mb-4">
                        <input
                          class="form-control form-control-lg"
                          :class="{
                            'tf-vue-is-invalid': $v.form.address1.$error,
                          }"
                          v-model.trim="$v.form.address1.$model"
                          :state="validateState('address1')"
                          aria-describedby="input-11-live-feedback"
                          @change="touchField($v.form.address1)"
                        />
                      </div>
                    </div>

                    <div
                      v-if="addressFound || defaultSite.domain === 'ie'"
                      class="row align-items-center"
                    >
                      <div
                        id="right"
                        class="form-group-control col-12 col-md-4 mb-4"
                      >
                        <label for="input-small" class="fw-bold">Address</label>
                      </div>

                      <div id="right" class="form-group col-12 col-md-8 mb-4">
                        <input
                          class="form-control form-control-lg"
                          v-model="form.address2"
                        />
                      </div>
                    </div>

                    <div
                      v-if="addressFound || defaultSite.domain === 'ie'"
                      class="row"
                    >
                      <div id="right" class="form-group col-12 col-md-4 mb-4">
                        <label for="input-small" class="fw-bold"
                          >Address *</label
                        >
                      </div>

                      <div class="form-group col-12 col-md-8 mb-4">
                        <input
                          class="form-control form-control-lg"
                          :class="{
                            'tf-vue-is-invalid': $v.form.address3.$error,
                          }"
                          aria-describedby="input-12-live-feedback"
                          v-model.trim="$v.form.address3.$model"
                          :state="validateState('address3')"
                          @change="touchField($v.form.address3)"
                        />
                      </div>
                    </div>

                    <div v-if="tripDetails.quoteType === 'ANNUALG'" class="row">
                      <div id="right" class="form-group col-12 col-sm-4 mb-4">
                        <label for="input-small" class="fw-bold"
                          >First Date of Travel</label
                        >
                      </div>

                      <div sm="5" class="col-12 col-sm-5">
                      <DatePicker 
                        v-model="$v.form.departureDate.$model" 
                        class="flex-grow" 
                        :min-date="min" 
                        :max-date="maxDate"
                      >
                        <template v-slot="{ inputValue, inputEvents }">
                          <input
                            id="$v.form.departureDate.$model"
                            :value="inputValue"
                            v-on="inputEvents"
                            placeholder='Select Start Date'
                            class="form-control form-control-lg w-100"
                          />
                        </template>
                      </DatePicker>
                        <div
                          v-if="$v.form.departureDate.$error"
                          class="alert alert-danger"
                        >
                          Please select a date.
                        </div>
                      </div>
                      <div class="row mt-5">
                        <div class="col-12">
                          <div class="border p-2">
                            <small>
                              <p class="fw-bold">
                                You are able to select a date up to 90 days from
                                today, reflecting your next intended date of
                                travel. You will receive cancellation cover from
                                today, the date of policy purchase.
                              </p>
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <!-- backpacker terms and conditions -->
                    <div class="row tf-vue-bg-grey-darker p-3 m-3">
                      <div v-if="(tripDetails.quoteType === 'BACKPACKER')" class="col-11">
                        <small>
                          Please tick the box to confirm that you have read and understood the <a :href="'/travel-insurance/' + defaultSite.studentipid" target="_blank">Insurance Product Information Document</a>  and <a :href="'/travel-insurance/' + defaultSite.studentpolicy" target="_blank"><strong>Policy Document Link</strong></a> on behalf of all insured persons, as the policy contains details of the 21 day cooling off period, our regulatory status, how to make a claim and the Insurer's complaints procedure. This insurance is being sold to you on a non-advised basis from a single insurer.  Cover is only available to individuals who have their primary residence in the United Kingdom, Channel Islands or Isle of Man. Certain sporting and hazardous activities may not be covered, full details may be found in the policy document.
                        </small>
                        <br/>
                        <br/>
                        <small>
                          Please note cover may be excluded for certain defined pre-existing Medical Conditions of persons not only booked to travel but also upon whom your travel depends. You should refer any medical condition which is not an <a data-bs-toggle="modal" data-bs-target="#backpackerMedicalModal" class="hover link-primary">Automatically covered Pre-existing medical condition </a> to the Insurer's Medical Screening Helpline who will confirm if additional cover can be provided and whether any optional additional premiums are payable. If the Medical Screening Helpline are not able to offer cover, or if you do not wish to pay any addition premium, then they will direct you to alternative policies including the <a href="https://www.moneyhelper.org.uk/en/everyday-money/insurance/travel-insurance-directory" target="_blank">Money Helper Directory</a> that may be able to do so, and the cost of your Travel Insurance policy will be refunded. Click here for the secure online medical screening service or call <a href="tel:01702 427237">01702 427237</a>. All communication is dealt with in the strictest confidence. 
                        </small>
                        <br/>
                        <br/>
                        <small>
                          Please note there is no cover for the entire duration of your trip if you commence travel contrary to any UK government or FCDO Advice.
                        </small>

                        <backpacker-medical-modal >
                        </backpacker-medical-modal> 
                      </div>
                      <!-- end of backpackers terms and conditions -->
                      <!-- start of regular Ts and cs -->
                      <div v-else class="col-11">
                      <small>
                        Please tick the box to confirm that you have read and understood the <a :href="'/travel-insurance/' + defaultSite.ipid" target="_blank">
                          Insurance Product Information Document</a>
                          and <a :href="'/travel-insurance/' + defaultSite.policy" target="_blank">Policy Document</a>
                          on behalf of all insured persons, as the policy contains details of the 21 day cooling off period, our regulatory status, how to make a claim and the Insurer's complaints procedure. This insurance is being sold to you on a non-advised basis from a single insurer. Cover is only available to individuals who have their primary residence in the United Kingdom, Channel Islands or Isle of Man. Certain sporting and hazardous activities may not be covered, full details may be found in the policy document.
                      </small>
                      <br/>
                      <br/>
                      <small>
                        Please note cover may be excluded for certain defined pre-existing medical conditions of persons not only booked to travel but also upon whom your travel depends. You should refer any medical condition to the insurer's Medical Screening Service who will confirm if additional cover can be provided and whether any optional additional premiums are payable. If the Medical Screening Service are not able to offer cover, or if you do not wish to pay any addition premium, then they will direct you to alternative policies including the <a href="https://www.moneyhelper.org.uk/en/everyday-money/insurance/travel-insurance-directory" target="_blank">Money Helper Directory</a> that may be able to do so, and the cost of your Travel Insurance policy will be refunded. <a target="_blank" :href="'https://policyscreening.com/trailfinders/'">
                        Click here</a> for the secure online medical screening service or call <a href="tel:01702 427237">01702 427237</a>. All communication is dealt with in the strictest confidence.
                      </small>
                      <br/>
                      <br/>
                      <small>
                        Please note there is no cover for the entire duration of your trip if you commence travel contrary to any UK government or FCDO Advice.
                      </small>
                      </div>
                      <!-- end of regular Ts and cs -->

                      <div class="form-group col-1" id="tAndCText">
                        <input
                          type="checkbox"
                          id="checkbox-2"
                          class="pb-3 form-input-control"
                          value="Yes"
                          :state="validateState('policy')"
                          :checked="form.policy ? true : false"
                          @change="
                            ($event) => {
                              form.policy = $event.target.value;
                            }
                          "
                        />
                      </div>
                    </div>

                    <div class="row my-5">
                      <div class="col-12">
                        <h6 class="form-title">Pay Securely</h6>
                        <small v-if="defaultSite.isStudent" class="text-strong">
                          However you choose to pay, your money is protected by
                          Trailfinders unrivalled consumer protection.
                        </small>
                        <small v-else class="text-strong">
                          However you choose to pay, your money is protected by
                          Trailfinders unrivalled consumer protection as all
                          client funds are protected in an independent Trust Account
                          and covered by the Trailfinders Financial Guarantee.
                        </small>
                      
                      </div>
                    </div>

                    <hr />
                    <div class="d-flex flex-column my-5" v-if="defaultSite.domain !== 'ie'">
                      <div>
                        <input
                          type="radio"
                          v-model="paymentType"
                          name="some-radios-pt"
                          value="Card"
                          id="some-radios-pt"
                          class="me-2"
                        />
                        <label for="some-radios-pt" class="fw-bold"
                          >Pay by Credit or Debit Card</label
                        >
                      </div>
                      <div>
                        <input
                          type="radio"
                          v-model="paymentType"
                          name="radio-size-pt"
                          value="AMEX"
                          id="some-radios-pt"
                          class="me-2"
                        />
                        <label label="some-radios-pt" class="fw-bold"
                          >Pay by Bank Transfer</label
                        >
                      </div>
                    </div>
                    <hr />
                    <div class="row">
                      <div class="form-group col-12 mb-4">
                        <label for="card-title" class="fw-bold"
                          >Cardholder's Title *</label
                        >
                        <select
                          id="card-title"
                          class="form-select form-select-lg w-100"
                          :class="{
                            'tf-vue-is-invalid': $v.form.cardTitle.$error,
                          }"
                          v-model="$v.form.cardTitle.$model"
                          :state="validateState('cardTitle')"
                          @change="touchField($v.form.cardTitle)"
                        >
                          <option
                            v-for="(title, index) in cardTitles"
                            :key="index"
                            :value="title.value"
                            >{{ title.text }}</option
                          >
                        </select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-4">
                        <label for="card-first-name" class="fw-bold"
                          >Cardholder's First Name *</label
                        >
                        <input
                          id="card-first-name"
                          v-model="$v.form.cardFirstName.$model"
                          class="form-control form-control-lg"
                          :class="{
                            'tf-vue-is-invalid': $v.form.cardFirstName.$error,
                          }"
                          type="text"
                          :state="validateState('cardFirstName')"
                          @change="touchField($v.form.cardFirstName)"
                        />
                      </div>
                      <div class="form-group col-12 mb-4">
                        <label for="card-surname" class="fw-bold"
                          >Cardholder's Surname *</label
                        >
                        <input
                          id="card-surname"
                          class="form-control form-control-lg"
                          :class="{
                            'tf-vue-is-invalid': $v.form.cardSurName.$error,
                          }"
                          v-model="$v.form.cardSurName.$model"
                          type="text"
                          :state="validateState('cardSurName')"
                          @change="touchField($v.form.cardSurName)"
                        />
                      </div>
                    </div>
                    <div class="btn-container d-flex justify-content-center">
                      <button
                        class="btn btn-dark rounded-0 my-2 w-30 tf-orange"
                        @click="onSubmit"
                        v-if="paymentType === 'Card'"
                      >
                        Confirm &amp; Buy
                      </button>

                      <div
                        v-if="paymentType === 'AMEX'"
                        class="d-flex flex-column justify-content-center align-items-center"
                      >
                        <strong> Click the Bank Transfer box below</strong
                        ><br />

                        <!-- below for bank transfer logo change without AMEX ---  -->

                        <button
                          type="button"
                          style="
                        height: 61px;
                        width: 317px;
                        background-image: url(https://icm.aexp-static.com/Internet/IMDC/paywithbank/images/pwb-desktop-dark.png); 
                        border: none;
                      "
                      @click="onSubmit()"
                        />
                      </div>
                    </div>

                    <div
                      class="mt-2 alert alert-danger"
                      v-if="peopleFieldsError"
                    >
                      <div class="d-flex justify-content-center fw-bold">
                        Please fill out each person's details
                      </div>
                    </div>

                    <div class="mt-2 alert alert-danger" v-if="addressError">
                      <div class="d-flex justify-content-center fw-bold">
                        Please fill out required addresses
                      </div>
                    </div>

                    <div class="mt-2 alert alert-danger" v-if="formNotValid">
                      <div class="d-flex justify-content-center fw-bold">
                        Please complete all required fields
                      </div>
                    </div>

                    <div class="alert alert-danger" v-if="formError">
                      <p class="fw-bold">
                        There has been an error processing your payment
                      </p>
                      <p class="fw-bold">
                        Please contact
                        <strong>{{ defaultSite.telephone }}</strong> for further
                        help.
                      </p>
                    </div>
                  </div>
                </form>
                <!-- /form -->
              </div>
            </div>
          </section>

          <div
            class="mt-2 alert alert-danger"
            v-if="amexStatus === 'AMEX_COMPLETE'"
          >
            <div>
              <div
                class="media-body d-flex flex-column align-items-center text-center"
              >
                <i class="material-icons vtd-pr-3 vtd-align-middle text-danger"
                  >&#xE002;</i
                >
                <span class="text-danger">
                  <span
                    class="glyphicon glyphicon-exclamation-sign"
                    aria-hidden="true"
                  ></span>
                  Unfortunately your bank has not authorised the payment.
                  <br /><br />
                  Please pay via another method or contact your bank for
                  details.
                </span>
              </div>
            </div>
          </div>

          <!--AMEX PENDING -->
          <div
            class="mt-2 alert alert-warning"
            v-if="
              amexStatus === 'AMEX_IN_PROGRESS' || amexStatus === 'AMEX_PENDING'
            "
          >
            <div
              class="warning d-flex flex-column align-items-center text-center"
            >
              <i class="material-icons vtd-pr-3 vtd-align-middle text-danger"
                >&#xE002;</i
              >
              Your payment is taking a little longer than expected to authorise.
              <br /><br />
              We will send you an email once confirmed.
              <br /><br />
              Thank you
              <br /><br />
              Your reference is:
              <strong>{{ tripDetails.bookingNumber }}</strong>
            </div>
          </div>

          <!--AMEX REQUOTE -->
          <div
            class="mt-2 alert alert-warning"
            v-if="amexStatus === 'AMEX_REQUOTE'"
          >
            <div
              class="warning d-flex flex-column align-items-center text-center"
            >
              <i class="material-icons vtd-pr-3 vtd-align-middle text-danger"
                >&#xE002;</i
              >
              The quote has changed from what was originally quoted.
              <br /><br />
              Please start your insurance quote again
              <br /><br />
              Thank you
              <br /><br />
            </div>
          </div>
          <div class="jumbotron border my-4 p-2">
            <p class="fs-5 text-center fw-bold">
              Pre-Existing Medical Conditions
            </p>
           
            <p class="text-center">
            If you would like to know if your pre-existing medical condition(s) can be covered and whether any optional additional premiums are payable direct to the insurer&apos;s medical screening helpline service prior to purchasing your Trailfinders Travel insurance policy, please <a 
                class="fw-bolder text-decoration-none"
                target="_blank"
                :href=" defaultSite.domain === 'ie'
                    ? 'https://policyscreening.com/trailfindersirl/'
                    : 'https://policyscreening.com/trailfinders/'
                ">click here</a>. 
            </p>
            <p v-if="(tripDetails.quoteType === 'BACKPACKER')" class="text-center">
              Certain pre-existing medical conditions are automatically covered and you do not need to call the medical screening helpline. Please click <a data-bs-toggle="modal" data-bs-target="#backpackerMedicalModal" class="fw-bolder text-decoration-none hover">Click here</a> to see the full list. 
              .<br/>
               <br/>
            </p>
           
          </div>
          <div class="jumbotron border my-4 p-2">
            <p class="fs-5 text-center fw-bold">Cooling off Period</p>
            <p class="text-center fw-bold">
              If for any reason you change your mind you can
              <strong
                >cancel within 21 days and we’ll refund you in full</strong
              >
              – no questions asked (providing travel has not commenced and you
              have not made a claim)
            </p>
          </div>

  

          <small v-if="defaultSite.domain !== 'ie'">
            Trailfinders Ltd, 48 Earls Court Road, London, W8 6FT is an
            Appointed Representative of Campbell Irvine Ltd 52 Earls Court Road,
            London, W8 6EJ, who is authorised and regulated by the
            Financial Conduct Authority (FCA). Their registration numbers can be
            checked with the FCA's by visiting
            <a href="http://www.fca.org.uk" target="_blank">www.fca.org.uk</a>
            or by contacting them on 0800 111 6768.
          </small>
        </div>
      </div>
    </div>

    <!-- Payment iFrame CONTENT -->
    <div
      v-if="paymentModal"
      @click="togglePaymentModal"
      class="tf-vue-modal-backdrop"
    >
      <div class="tf-vue-modal">
        <div>
          <div class="content">
            <section
              v-if="barclaysError | !isConnected"
              class="rd-flex justify-content-center ml-5 mb-3"
            >
              <div
                class="col-10 col-md-10 alert alert-warning ml-5 w-100 text-center"
              >
                <p class="fw-bold">
                  Unfortunately we have not been able to process your request.
                  <br />
                  To complete your order, please call Trailfinders Insurance on
                  <strong>{{ defaultSite.telephone }}</strong>
                </p>
              </div>
            </section>
            <div
              v-else-if="isLoading"
              class="d-flex justify-content-center mb-3"
            >
              <!-- <b-spinner label="Loading..."></b-spinner> -->
            </div>
            <div v-else class="col-12 col-md-12">
              <section v-if="paymentError" class="row form-group mt-3">
                <div class="col-12 col-md-12 alert alert-warning ">
                  <p class="fw-bold">
                    Your payment has been unsuccessful.
                    <br />
                    <br />
                    Please carefully check your card details and try again.
                    <br />
                    If you are unsuccessful, please call us on
                    <strong>{{ defaultSite.telephone }}</strong> where one of
                    our team members will be happy to assist you and complete
                    your purchase.
                  </p>
                  <p>
                    Your card has not been charged.
                    <br />
                    <br />
                    Thank You
                  </p>
                </div>
              </section>

              <section v-else-if="paymentSuccess" class="row form-group mt-3">
                <div class="col-12 col-md-12 alert alert-success fw-bold">
                  Your payment for
                  <strong
                    >{{ defaultSite.symbol }}{{ data.purchaseAmount }}</strong
                  >
                  has been successful.
                  <br />
                  <br />
                  If you require any help then please contact Trailfinders on
                  <strong>{{ defaultSite.telephone }}</strong>
                </div>
              </section>
              <section
                v-else-if="barclaysModalError"
                class="rd-flex justify-content-center ml-5 mb-3"
              >
                <div class="col-10 col-md-10 alert alert-warning ml-5">
                  <p class="fw-bold">
                    Unfortunately we have not been able to process your request.
                    <br />
                    To complete your order, please call Trailfinders Insurance
                    on
                    <strong>{{ defaultSite.telephone }}</strong>
                  </p>
                </div>
              </section>
              <iframe v-else id="payment-frame" :src="barclaysUrl"></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- END Payment iFrame CONTENT -->
  </section>
</template>

<script>
import { cover } from "../amounts/cover";
import moment from "moment";
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  requiredIf,
} from "vuelidate/lib/validators";
import {
  getAddressInfo,
  getFullAddressInfo,
  getCountries,
  logSubmit,
  amexButtonPayment,
  amexUpdate,
} from "@/services/api.js";
import { getDay } from "@/services/stepsAttributes";
import { mapActions, mapGetters } from "vuex";
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

const jwt = require("jsonwebtoken");
const { v4: uuidv4 } = require("uuid");
const token = jwt.sign({ data: uuidv4() }, "VnR9.vVnB7qQM*Y_", {
  expiresIn: "15m",
});

export default {

  sockets: {
    connect: function() {
      this.isConnected = true;
    },
    begin: function() {},
    beginResponse: function(resp) {
      if (resp && resp.paymentRedirectUrl) {
        this.barclaysStage1 = false;
        this.barclaysStage2 = true;
        this.barclaysUrl = resp.paymentRedirectUrl;
        if (this.barclaysUrl !== "") {
          this.barclaysError = false;
          this.isLoading = false;
        }
      } else {
        this.barclaysError = true;
        this.isLoading = false;
      }
    },
    finished: async function(finishedResponse) {
      if (finishedResponse && finishedResponse.success === true) {
        this.paymentSuccess = true;
        const res = finishedResponse.result;

        if (!res.bookno || res.bookno === undefined) {
          this.formError = true;
          this.log.GUID = this.quoteSingle.GUID;
          this.log.EMAIL = this.form.email;
          this.log.COVERTYPE = this.tripDetails.quoteType;
          this.log.OPTION = this.quoteSingle.OPTION;
          this.log.STAGE = "PAYMENT";
          this.log.STATUS = "ERROR";
          this.log.STATUSMSG = "Payment Failed";
          await logSubmit(this.log);
          return;
        } else {
          this.updateBookingNum(res.bookno);

          this.log.GUID = this.quoteSingle.GUID;
          this.log.EMAIL = this.form.email;
          this.log.COVERTYPE = this.tripDetails.quoteType;
          this.log.OPTION = this.quoteSingle.OPTION;
          this.log.STAGE = "PAYMENT";
          this.log.STATUS = "OK";
          this.log.STATUSMSG = "Payment Success";
          await logSubmit(this.log);

          window.scrollTo(0, 0);
          this.paymentModal = false;
          this.$router.push("/step4");
        }
      } else if (finishedResponse && finishedResponse.error) {
        this.barclaysStage1 = false;
        this.barclaysStage2 = false;
        this.paymentError = true;
        this.isLoading = false;
      } else {
        this.barclaysError = true;
        this.isLoading = false;
      }
    },
  },
  mixins: [validationMixin],
  props: ["defaultSite"],
  components: {DatePicker},
  data() {

    return {
      paymentModal: false,
      barclaysStage1: false,
      barclaysStage2: false,
      barclaysError: false,
      isConnected: true,
      isLoading: false,
      barclaysUrl: null,
      paymentError: null,
      barclaysModalError: null,
      paymentSuccess: false,
      cover,
      form: {
        email: "",
        telephone: null,
        postcode: "",
        address1: "",
        address2: "",
        address3: "",
        departureDate: "",
        policy: "",
        cardTransaction: "",
        cardNumber: "",
        cardCVV: "",
        cardExpMonth: "",
        cardExpYear: "",
        cardTitle: "",
        cardFirstName: "",
        cardSurName: "",
        cardPaymentTotal: "",
      },
      titleOptions: [
        { text: "Title", value: null },
        { text: "Mr", value: "Mr" },
        { text: "Ms", value: "Ms" },
        { text: "Miss", value: "Miss" },
        { text: "Mrs", value: "Mrs" },
        { text: "Sir", value: "Sir" },
        { text: "Lady", value: "Lady" },
        { text: "Dr", value: "Dr" },
      ],
      days: getDay(),
      months: [
        { text: "MM", value: null },
        { text: "Jan", value: "01" },
        { text: "Feb", value: "02" },
        { text: "Mar", value: "03" },
        { text: "Apr", value: "04" },
        { text: "May", value: "05" },
        { text: "Jun", value: "06" },
        { text: "Jul", value: "07" },
        { text: "Aug", value: "08" },
        { text: "Sep", value: "09" },
        { text: "Oct", value: "10" },
        { text: "Nov", value: "11" },
        { text: "Dec", value: "12" },
      ],
      countries: [],
      address: "",
      addressOptions: [],
      addressFound: false,
      addressDataReturned: false,
      addressData: "",
      clickedSubmit: false,
      token: token,
      min: new Date(),
      cardExpiryMonth: [
        { text: "MM", value: null },
        { text: "01", value: "01" },
        { text: "02", value: "02" },
        { text: "03", value: "03" },
        { text: "04", value: "04" },
        { text: "05", value: "05" },
        { text: "06", value: "06" },
        { text: "07", value: "07" },
        { text: "08", value: "08" },
        { text: "09", value: "09" },
        { text: "10", value: "10" },
        { text: "11", value: "11" },
        { text: "12", value: "12" },
      ],
      cardExpiryYear: [],
      cardTitles: [
        { text: "Cardholder's Title", value: null },
        { text: "Mr", value: "Mr" },
        { text: "Ms", value: "Ms" },
        { text: "Mrs", value: "Mrs" },
        { text: "Sir", value: "Sir" },
        { text: "Lady", value: "Lady" },
        { text: "Dr", value: "Dr" },
      ],
      formError: false,
      formNotValid: false,
      peopleFieldsError: false,
      missingAddress: false,
      log: {},
      isActive: true,
      data: null,
      amexStatus: null,
      amexComplete: false,
      paymentType: "Card",
    };
  },
  mounted() {
    window.scroll({
      top: 0,
      behavior: "instant",
    });
  },
  validations: {
    form: {
      email: {
        required: required,
        email: email,
        minLength: minLength(3),
      },
      telephone: {
        required,
      },
      postcode: {
        required: required,
      },
      address1: {
        required: required,
        minLength: minLength(3),
      },
      address3: {
        required: required,
        minLength: minLength(2),
      },
      departureDate: {
        required: requiredIf(function() {
          return this.tripDetails.quoteType === "ANNUALG";
        }),
      },
      policy: {
        required: required,
      },

      cardTitle: {
        required: required,
      },
      cardFirstName: {
        required: required,
      },
      cardSurName: {
        required: required,
      },
    },
  },
  async created() {
    if (!this.tripDetails.totalNumberOfPeople) {
      this.$router.push("/step1");
    }
    getCountries().then((res) => {
      this.countries = res;
    });
    this.cardExpiryYear = this.expiryYears;
    this.defaultNationality();
    this.min = moment().format('YYYY-MM-DD');
  },
  computed: {
    ...mapGetters({
      quoteSingle : "getQuoteSingle",
      quoteAnnual : "getQuoteAnnual",
      quoteBackpacker : 'getQuoteBackpacker',
      tripDetails : "getTripDetailsInfo",
    }),
    maxDate() {
      return moment()
        .add(90, "days")
        .format("YYYY-MM-DD");
    },
    addressError() {
      return this.missingAddress;
    },

    formDEP() {
      if(this.form.departureDate) {
        return moment(this.form.departureDate).format("DD/MM/YYYY");
      }
      return 'No Dept Date'
    },
    dobYears() {
      const arrYears = [{ name: "YYYY", value: null }];
      for (let i = 0; i <= 76; i++) {
        arrYears.push({
          name: moment()
            .subtract(i, "y")
            .format("YYYY"),
          value: moment()
            .subtract(i, "y")
            .format("YYYY"),
        });
      }
      return arrYears;
    },
    expiryYears() {
      const arrYears = [{ name: "YYYY", value: null }];
      for (let i = 0; i <= 10; i++) {
        arrYears.push({
          name: moment()
            .add(i, "y")
            .format("YYYY"),
          value: moment()
            .add(i, "y")
            .format("YYYY"),
        });
      }
      return arrYears;
    },
    fromDate() {
      return moment(this.tripDetails.fromDate, "YY-MM-DD").format(
        "D MMMM YYYY"
      );
    },
    toDate() {
      return moment(this.tripDetails.toDate, "YY-MM-DD").format(
        "D MMMM YYYY"
      );
    },
  },
  watch: {
    async $route(to) {
      // Watching for AMEX route change
      if (to.name === "amex") {
        this.amexComplete = true;
        const payload = {
          status: this.$route.query.status,
          request_id: this.$route.query.request_id,
          transaction_details: this.$route.query.transaction_details,
        };

        let result = await amexUpdate(payload);

        if (result.error) {
          this.errorLoadingData = true;
          this.formError = true;
          this.log.GUID = this.quoteSingle.GUID;
          this.log.EMAIL = this.form.email;
          this.log.COVERTYPE = this.tripDetails.quoteType;
          this.log.OPTION = this.quoteSingle.OPTION;
          this.log.STAGE = "PAYMENT";
          this.log.STATUS = "ERROR";
          this.log.STATUSMSG = "Payment Failed";
          await logSubmit(this.log);
          return;
        }
        this.amexData = result.data;
        if (this.amexData.status) {
          this.amexStatus = this.amexData.status;
        }
        // Happy path first - we have a complete payment
        if (this.amexStatus === "AMEX_COMPLETE") {
          if (this.amexData.sf_booking_number) {
            this.updateBookingNum(this.amexData.sf_booking_number);
          } else {
            this.updateBookingNum(this.amexData.order_id);
          }

          this.log.GUID = this.quoteSingle.GUID;
          this.log.EMAIL = this.form.email;
          this.log.COVERTYPE = this.tripDetails.quoteType;
          this.log.OPTION = this.quoteSingle.OPTION;
          this.log.STAGE = "PAYMENT";
          this.log.STATUS = "OK";
          this.log.STATUSMSG = "Payment Success";
          await logSubmit(this.log);

          window.scrollTo(0, 0);

          this.$router.push("/step4");
        }
        // Pending Status - we have a pending payment
        if (
          this.amexStatus === "AMEX_PENDING" ||
          this.amexStatus === "AMEX_IN_PROGRESS"
        ) {
          this.updateBookingNum(this.amexData.order_id);
          this.log.GUID = this.quoteSingle.GUID;
          this.log.EMAIL = this.form.email;
          this.log.COVERTYPE = this.tripDetails.quoteType;
          this.log.OPTION = this.quoteSingle.OPTION;
          this.log.STAGE = "PAYMENT";
          this.log.STATUS = "PENDING";
          this.log.STATUSMSG = "Payment Pending For Amex";
          await logSubmit(this.log);
          // We are not going to change route - instead display alert box
        }
        if (this.amexStatus === "ERROR") {
          this.log.GUID = this.quoteSingle.GUID;
          this.log.EMAIL = this.form.email;
          this.log.COVERTYPE = this.tripDetails.quoteType;
          this.log.OPTION = this.quoteSingle.OPTION;
          this.log.STAGE = "PAYMENT";
          this.log.STATUS = "ERROR";
          this.log.STATUSMSG = "Payment ERROR For Amex";
          await logSubmit(this.log);
          // We are not going to change route - instead display alert box
        }
      }
    },
  },
  methods: {
    togglePaymentModal() {
      this.paymentModal = !this.paymentModal;
    },
    testAmex() {
      this.$router.push({
        path:
          "/amex/68b927b5-1339-6115-c4ff-4e85921e899a?status=success&request_id=3df3750d-8179-476e-8d35-bf65314965e0&transaction_details=eyJraWQiOiJpZF84bWxsUklQcSIsImFsZyI6IkhTMjU2In0.eyJhbW91bnQiOiIxNjUuMDAiLCJjdXJyZW5jeSI6IkdCUCIsInRpbWVzdGFtcCI6MTYzODg5NTQzMzc2OCwib3JkZXJfaWQiOiJJTlNVUkFOQ0UtMDAwMDAwMDUiLCJjb3JyZWxhdGlvbl9pZCI6IjQ2NzkxMzVjLTJkY2YtNDNjMy05OTFlLWY0Y2NhODhmZmE4ZCIsInJlcXVlc3RfaWQiOiIzZGYzNzUwZC04MTc5LTQ3NmUtOGQzNS1iZjY1MzE0OTY1ZTAiLCJ0cmFuc2FjdGlvbl9pZCI6IjgzMjM5ZjEzOGNhZjQ3NTBiNDUwYjU5M2U4N2I4NjU2IiwicGF5bWVudF9zdGF0dXMiOiJBY2NlcHRlZFNldHRsZW1lbnRDb21wbGV0ZWQiLCJiYW5rX3JlZmVyZW5jZV9pZCI6IlBXQlQxNjM4ODk1NDE1NDE2In0.vxamxqc5D8DgJYEHxdh2EEhfNohI63JiV0ih8LklbgQ",
      });
    },
    ...mapActions([
      "updateBookingNum",
      "updateDepartureDate",
      "updatePassengers",
      "updateEmail",
    ]),
    defaultNationality() {
      for (let i = 1; i < this.tripDetails.peopleAges.length + 1; i++) {
        this.defaultSite.domain === "ie"
          ? (this.form[`nationality${i}`] = "IE")
          : (this.form[`nationality${i}`] = "GB");
      }
    },
    checkAddress() {
      !this.form.address1 && !this.form.address3
        ? (this.missingAddress = true)
        : false;
    },
    touchField(field) {
      if (field && typeof field.touch === "function") {
        field.touch();
      }
    },

    

    async onSubmit(event) {
      this.formError = false;
      this.formNotValid = false;
      this.peopleFieldsError = false;
      this.missingAddress = false;
      this.checkAddress();
      this.data = {}

      if (event) {
        event.preventDefault();
      }
      this.$v.$touch();

      this.log.GUID = this.quoteSingle.GUID;
      this.log.EMAIL = this.form.email;
      this.log.COVERTYPE = this.tripDetails.quoteType;
      this.log.OPTION = this.quoteSingle.OPTION;
      this.log.DEPDATE = this.formDEP;
      this.log.DATEFROM = this.quoteSingle.DATEFROM;
      this.log.DATETO = this.quoteSingle.DATETO;
      if(this.tripDetails.quoteType === 'ANNUALG') {
        this.log.DATEFROM = moment(this.formDEP, 'DD/MM/YYYY').format('YYMMDD');
        this.log.DATETO = moment(this.formDEP, 'DD/MM/YYYY').add(1, 'years').format('YYMMDD');
      }
      
      ///the below 2 lines use deprecated code///
      //this.log.OS = window.navigator.userAgentData.platform
      //this.log.ISMOBILE = window.navigator.userAgentData.mobile.toString()
      this.log.STAGE = "BEFORE VALIDATION";
      this.log.STATUS = "OK";
      this.log.STATUSMSG = "Form Submitted";
      await logSubmit(this.log);
      const SFObj = {};
      const passengers = [];
      // Initial check to see if passenger's details aren't empty
      for (let i = 1; i < this.tripDetails.peopleAges.length + 1; i++) {
        const numP = {};
        this.form[`title${i}`] === undefined
          ? (this.peopleFieldsError = true)
          : (SFObj[`TITLE${i}`] = this.form[`title${i}`]);
        numP[`TITLE${i}`] = this.form[`title${i}`];

        this.form[`firstName${i}`] === undefined
          ? (this.peopleFieldsError = true)
          : (SFObj[`FIRSTNAME${i}`] = this.form[`firstName${i}`]
              .normalize("NFD")
              .replace(/\p{Diacritic}/gu, ""));
        numP[`FIRSTNAME${i}`] = this.form[`firstName${i}`];

        this.form[`surName${i}`] === undefined
          ? (this.peopleFieldsError = true)
          : (SFObj[`SURNAME${i}`] = this.form[`surName${i}`]
              .normalize("NFD")
              .replace(/\p{Diacritic}/gu, ""));
        numP[`SURNAME${i}`] = this.form[`surName${i}`];

        this.form[`dobDay${i}`] === undefined
          ? (this.peopleFieldsError = true)
          : (SFObj[`DOBD${i}`] = this.form[`dobDay${i}`]);
        this.form[`dobMonth${i}`] === undefined
          ? (this.peopleFieldsError = true)
          : (SFObj[`DOBM${i}`] = this.form[`dobMonth${i}`]);
        this.form[`dobYear${i}`] === undefined
          ? (this.peopleFieldsError = true)
          : (SFObj[`DOBY${i}`] = this.form[`dobYear${i}`]);
        const dob = SFObj["DOBD" + i] + SFObj["DOBM" + i] + SFObj["DOBY" + i];
        SFObj["DOB" + i] = moment(dob, "DD/MM/YYYY").format("DD/MM/YYYY");

        this.form[`nationality${i}`] === undefined
          ? (this.peopleFieldsError = true)
          : (SFObj[`NATIONALITY${i}`] = this.form[`nationality${i}`]);
        // re-format AGE & EDU for SF
        SFObj[`AGE${i}`] = this.tripDetails.peopleAges[i - 1].AGE;
        this.data[`AGE${i}`] = this.tripDetails.peopleAges[i - 1].AGE.toString();
        if (this.tripDetails.peopleAges[i - 1].EDU) {
          SFObj[`EDU${i}`] = this.tripDetails.peopleAges[i - 1].EDU;
        }

        passengers.push(numP);
      }
      if (
        !this.$v.$invalid &&
        !this.peopleFieldsError &&
        !this.missingAddress
      ) {
        this.updateEmail(this.form.email);
        this.updatePassengers({ passengers: passengers });
        this.data.country = this.defaultSite.nedstat;
        this.data.site = "TF";
        this.data.title = this.form.cardTitle;
        this.data.firstname = this.form.cardFirstName
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "");
        this.data.surname = this.form.cardSurName
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "");
        this.data.name =
          this.form.cardTitle +
          " " +
          this.data.firstname +
          " " +
          this.data.surname;
        this.data.billingAddressLine1 = this.form.address1
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "");
        this.data.billingAddressLine2 = this.form.address2
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "");
        this.data.billingAddressLine3 = this.form.address3
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "");
        this.data.billingAddressPostcode = this.form.postcode
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "");
        this.data.currencyCode = this.defaultSite.name;
        this.data.purchaseAmount = this.tripDetails && this.tripDetails[this.tripDetails.quoteType === 'BACKPACKER' ? 'quoteInfoBackpacker' : 'quoteInfoSingle'].premium.trim();
        this.data.purchaseDescription = "Insurance something";
        this.data.dubdiscount = parseInt(this.quoteSingle.DUBDISCOUNT);
        this.data.adults = this.quoteSingle.ADULTS;
        this.data.children = this.quoteSingle.CHILDREN;
        this.data.covertype = this.tripDetails.quoteType;
        this.data.cruise = this.quoteSingle.CRUISE;
        this.data.dateFrom = this.quoteSingle.DATEFROM;
        this.data.dateTo = this.quoteSingle.DATETO;
        this.data.depDate = this.formDEP;
        this.data.destination = this.quoteSingle.DESTINATION;
        this.data.duration = this.tripDetails && this.tripDetails[this.tripDetails.quoteType === 'BACKPACKER' ? 'quoteInfoBackpacker' : 'quoteInfoSingle'].duration
        this.data.email = this.form.email;
        this.data.familyDiscount = this.quoteSingle.FAMILYDISCOUNT;
        this.data.infants = this.quoteSingle.INFANTS;
        this.data.option = this.quoteSingle.OPTION;
        this.data.paySource = "INS";
        this.data.phone = this.form.telephone;
        this.data.winterSport = this.quoteSingle.WINTERSPORT;

        if (this.tripDetails.quoteType === "ANNUALG") {
          this.data.destination = "3";
          this.data.winterSport = "1";
          this.data.cruise = this.quoteAnnual.CRUISE;
          this.data.familyDiscount = this.quoteAnnual.FAMILYDISCOUNT;
          this.data.purchaseAmount = this.quoteAnnual.PREMIUM;
          this.data.depDate = this.formDEP;
          this.data.dateFrom = moment(this.formDEP, 'DD/MM/YYYY').format('MMDDYY');
          this.data.dateTo = moment(this.formDEP, 'DD/MM/YYYY').add(1, 'years').format('MMDDYY');
          this.data.duration = "12M";
          this.updateDepartureDate(this.formDEP);
        }
        this.data.persons = [];
        for (let i = 1; i < this.tripDetails.peopleAges.length + 1; i++) {
          if (SFObj[`TITLE${i}`]) {
            this.data.persons.push({
              title: SFObj[`TITLE${i}`],
              firstname: SFObj[`FIRSTNAME${i}`].normalize('NFD').replace(/\p{Diacritic}/gu, ''),
              surname: SFObj[`SURNAME${i}`].normalize('NFD').replace(/\p{Diacritic}/gu, ''),
              nationality: SFObj[`NATIONALITY${i}`],
              dob: SFObj[`DOB${i}`],
              dobd: SFObj[`DOBD${i}`],
              dobm: SFObj[`DOBM${i}`],
              doby: SFObj[`DOBY${i}`],
              age: SFObj[`AGE${i}`],
            });
          }
        }

        if (this.paymentType === "AMEX") {
          // Depends on payment type - AMEX or Card
          await this.loadAmexButton();
        } else {
          this.$socket.emit("beginInsurance", this.data);
          this.paymentModal = true;
        }
      } else {
        this.log.GUID = this.quoteSingle.GUID;
        this.log.EMAIL = this.form.email;
        this.log.COVERTYPE = this.tripDetails.quoteType;
        this.log.OPTION = this.quoteSingle.OPTION;
        this.log.STAGE = "FORM VALIDATION";
        this.log.STATUS = "ERROR";
        this.log.STATUSMSG = "Form Invalid";
        await logSubmit(this.log);

        this.formNotValid = true;
      }
    },
    async loadAmexButton() {
      this.data.customerId = this.guid();
      this.data.insuranceData = Object.assign({}, this.data);
      const result = await amexButtonPayment(this.data);
      if (result.status === "REQUOTE") {
        this.amexStatus = "AMEX_REQUOTE";
        this.amexComplete = true;
      }
    },
    guid() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return (
        s4() +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        s4() +
        s4()
      );
    },
    async addressInfo(event) {
      event.preventDefault();
      this.addressFound = false;
      this.addressData = false;

      if (this.form.postcode !== "") {
        let res = await getAddressInfo(
          this.form.postcode,
          this.defaultSite.domain
        );
        if (res.error) {
          return res.error;
        } else {
          if (res.length > 0) {
            this.addressDataReturned = true;
            this.addressOptions = res;
          } else {
            this.addressFound = true;
          }
        }
      }
    },
    async fullAddressInfo(event) {
      this.addressFound = false;
      event.preventDefault();

      let res = await getFullAddressInfo(
        this.address.format,
        this.defaultSite.domain
      );
      if (res.error) {
        return res.error;
      } else {
        this.addressDataReturned = false;
        this.addressFound = true;
        for (let i = 0; i < res.length; i++) {
          if (res[i].addressLine1) {
            this.form.address1 = res[i].addressLine1;
          }
          if (res[i].addressLine2) {
            this.form.address2 = res[i].addressLine2;
          }
          if (res[i].locality) {
            this.form.address3 = res[i].locality;
          }
          if (res[i].postalCode) {
            this.form.postcode = res[i].postalCode;
          }
        }
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    goBack() {
      this.$router.push("/step2");
    },
  },
};
</script>

<style lang="scss" scoped>
select {
  background-color: rgba(0,0,0,0);
  box-shadow: none !important;
  border: none;
  border-bottom: 1.5px solid rgb(186, 186, 186);
  border-radius: 0%;
}
input {
  box-shadow: none !important;
  background-color: rgba(0,0,0,0);
  border: none;
  border-bottom: 1.5px solid rgb(186, 186, 186);
  border-radius: 0%;
}
select :focus-visible {
  outline: none !important;
  box-shadow: none !important;
  border: none;
  border-bottom: 1.5px solid rgb(186, 186, 186);
}
select :focus {
  outline: none !important;
  box-shadow: none !important;
  border: none;
  border-bottom: 1.5px solid rgb(186, 186, 186);
}
.main-container {
  background-color: #fff;
}
label {
  font-weight: 100;
}
.error {
  background-color: #cc0000;
}
.default {
  background-color: #9cc06e;
}
.autoaddress-control .autoaddress-text-box {
  color: #333;
  height: 50px;
  padding: 3px;
  margin-left: 5px;
  display: block;
  width: 70%;
  font-size: 14px;
  line-height: 1.42857;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.autoaddress-control .autoaddress-button {
  background-color: #428bca;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background-image: none;
  -webkit-user-select: none;
  font-size: 16px;
  font-weight: 700;
  color: white;
  height: 50px;
  border-color: #357ebd;
  border-radius: 5px;
  white-space: normal;
}

// Hide cvv input type number arrows
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
#payment-frame {
  border: 0px;
  margin: auto;
  width: 100%;
  height: 400px;
}
.tf-vue-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  padding: 50px;
  z-index: 100000;
}
.tf-vue-modal {
  position: relative;
  width: 100%;
  background-color: #fff;
  opacity: 1 !important;
}
.summary-title-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 1em;
}
.summary-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  width: 65%;
}
.defaqto-logo {
  display: flex;
  flex-direction: row;
  justify-content: end;
  width: 35%;
}
</style>
